module.exports = __webpack_public_path__ + "assets/img/Snipaste_2023-11-29_18-18-20.694c4f31.jpg";